import type { TrackDataUnion } from "common-types";

/**
 * Pushed a tracking event to the `window.fandomTrack` queue so the Tracker in the host app can
 * pick up the event and emit it to the proper destination.
 *
 * This can be used at anytime during the lifecycle of the app and the event will be picked up when
 * the tracker is ready, or handled immediately if the tracker is ready to accept tracks.
 *
 * @param event The track event being recorded
 * @param payload The track payload that contains the data for this event.
 */
export function pushTrack(
  event: TrackDataUnion["event"],
  payload: TrackDataUnion["payload"],
): void {
  window.fandomTrack = window.fandomTrack ?? { q: [] };
  window.fandomTrack.q.push({
    event,
    payload,
  } as TrackDataUnion);
}
